module.exports = __webpack_public_path__ + "static/media/isimicinlogo.703d046e.png";